import { DisplayParams } from '@marketing/insights/insights.interface';
import { Link, WidenAsset } from '@types';

export interface ArticleContent {
  articleID?: string;
  linkWidenAsset?: {
    displayText: string;
    target: string;
    widenAssetCompound: WidenAsset;
  };
  title: string;
  hideDate?: boolean;
  isArchive?: boolean;
  doNotArchive?: boolean;
  date?: number;
  isodate?: string;
  image?: WidenAsset;
  audio?: WidenAsset;
  cardImageOnly?: boolean;
  imgSrc?: string;
  pdf?: Array<any>;
  localizablePdf?: Array<PDFLinks>;
  audioHref?: string;
  readingTime?: number;
  cardSummary?: string;
  logo?: WidenAsset | string;
  SIM?: {
    logoSrc?: string;
    logoAltText?: string;
    logoTheme?: string;
    logoBackgroundColor?: string;
    logoHref?: string;
  };
  contributors?: Array<Contributor>;
  investmentteam?: Array<string>;
  investmenttheme?: Array<string>;
  speciality?: Array<string>;
  publicationseries?: Array<string>;
  audienceExclusions?: Array<string>;
  authors?: Array<string>;
  relatedContent?: Array<RelatedContent>;
  alternativeArticle?: AlternativeArticle;
  contentBlocks?: Array<any>;
  filterContent?: Array<string>;
  rightRail?: Array<any>;
  insightMetadata: any;
  // TODO: ADD `rightRail` option here

  legal?: string;
  socialMedia?: boolean;
  subscribe?: boolean;
  sections?: Array<any>;
  company?: string;
  contactName?: string;
  contactTelephone?: string;
  contentType?: string;
  displayInsightsCards?: boolean;
  insightsCardsHeader?: string;
  insightsCardsFilters?: DisplayParams;
  archiveLabel?: string;
  eyebrow?: {
    trademark?: string;
    collections?: string;
    topic?: string;
  };
  assetclassPage?: string[];
  mediaTag?: {
    label?: string;
    type?: string;
  };
  seoMetadata?: ArticleSeoMetadata;
  targetingLinkCompound?: Array<TargetedLinkCompound>;
  contributorsBiography?: Array<ContributorsBiography>;
  biographyDynamicProfile?: Array<BiographyDynamicProfile>;
}

export interface TargetedLinkCompound {
  contentType?: string;
  displayName?: string;
  link?: Link;
  name?: string;
  targeting?: any;
  isAllowed?: boolean;
  isNewWindow?: boolean;
  iconType?: string;
}

export interface ArticleSeoMetadata {
  metaTitle?: string;
  metaDescription?: string;
  metaKeywords?: string;
  noindex?: boolean;
  nofollow?: boolean;
  canonicalURL?: string;
  socialMediaTitle?: string;
  socialMediaDescription?: string;
  includeInSitemap?: boolean;
}

export interface PDFLinks {
  targeting: string;
  isAllowed: boolean;
  pdf: {
    title?: string;
    displayText?: string;
    external?: boolean;
    target?: string;
    href?: string;
    isNewWindow?: boolean;
    widenAssetCompound?: WidenAsset;
  };
}

export interface Contributor {
  fullName?: string;
  profileImage?: WidenAsset;
  profileImageUrl: string;
  businessGroupTeam?: string;
  overview?: string;
  text2?: string;
  displayName?: string;
  contentType?: string;
  role?: string;
  qualifications?: string;
  employer?: string;
  href?: string;
  sharedUrl?: string;
  relativePath?: string;
}

export interface CardData {
  cardCompound?: Array<any>;
  spacingBottom?: string;
  style?: string;
  link?: any;
  targeting?: string;
  isAllowed?: boolean;
}

export interface RelatedContent {
  heading?: string;
  showHeading?: boolean;
  localizableLink?: {
    link?: Link;
    targeting?: any;
    isAllowed?: boolean;
    isodate?: string;
    dateString?: string;
  }[];
  dynamicFilters?: {
    articleFilters: any;
    maxResults: number;
    displayDynamicRelatedContent?: boolean;
  };
}

export interface AlternativeArticle {
  title?: string;
  link?: string;
}
export interface PageContents {
  jumplinks: Array<{ id?: string; title?: string }>;
}

export interface ArticleSpacing {
  spacingBottom?: string;
  isMainContent?: boolean;
  type?: string;
}

export interface ArticleProfileSetting {
  useProfileLink?: boolean;
  profileBasePath?: string;
  profileLinkRelativePath?: string;
  hideContactBlock?: boolean;
}

export enum ProfileContentType {
  FTCORE_PROFILE = 'ftcore:Profile',
  FTBLOG_PROFILE = 'ftblogs:authorDocument',
}

export interface ContributorsBiography {
  biographyDynamicProfile?: string;
  contentType?: string;
}

export interface BiographyDynamicProfileJson {
  name?: string;
  overview?: string;
  text1?: string;
  employeeId?: string;
  imageUrl?: string;
  profilePath?: string;
  documentName?: string;
  documentPath?: string;
  jobTitle1?: string;
  jobTitle2?: string;
}

export interface BiographyDynamicProfile {
  fullName?: string;
  overview?: string;
  text1?: string;
  employeeId?: string;
  profileImageUrl?: string;
  profilePath?: string;
  documentName?: string;
  fallbackImgSrc?: string;
}
